module.exports = __webpack_public_path__ + "img/14.a7954574.png";